import React, { Component } from 'react';
import { Button, Input, Modal, Tree, message } from "antd";
import $ from '../../common/AjaxRequest';
import API_URL from '../../common/url';

const TreeNode = Tree.TreeNode;

class SelectProvince extends Component {
    constructor(props) {
        super(props);
        const { areaName = '' } = props; 
        this.state = {
            areaName,
            showTree: false,
            treeData: {},
            checkedArea: [],
        }
    }

    loadTreeData = () => {
        const options = {
            method: 'POST',
            url: `${API_URL.summary.getRegionTree}`,
            data: {},
            dataType: 'json',
            doneResult: res => {
                if (!res.error) {
                    this.setState({ treeData: res.treeData });
                } else {
                    message.error(data.error);
                }
            }
        }
        $.sendRequest(options)
    }

    showTree = () => {
        this.setState({ showTree: true });
    }

    hideTree = () => {
        this.setState({ showTree: false });
    }

    onTreeCheck = (checkedKeys, info) => {
        const checkedArea = info.checkedNodes;
        const areaName = checkedArea.map(d => d.props.title);
        this.setState({
            areaName,
            checkedArea,
        }, () => {
            this.props.saveProvince(info.checkedNodes);
        });
    }

    onSelect = (selectedKeys, info) => {
        const child = info.node.props.children || [];
        if (child.length <= 0) {
            const checkedArea = info.selectedNodes;
            const areaName = checkedArea.map(d => d.props.title);
            this.setState({
                areaName,
                checkedArea,
            }, () => {
                this.props.saveProvince(selectedKeys);
            });
        } else {
            selectedKeys.pop();
            message.warning('请选择地区最后一级选项');
        }
    }

    getContent = () => {
        const { treeData = {} } = this.state;
        let data = null;
        if (Object.keys(treeData).length > 0) {
            data = (
                <TreeNode title={treeData.title} key={treeData.key} >
                    { this.loopCity(treeData.children, '') }
                </TreeNode>
            );
        }
        return data;
    }

    loopCity = (data, area) => {
        const { selectCity = false } = this.props;
        return data.map(item => {
            const { key, regionType } = item;
            if (regionType === 'AREA') {
                area = key;
            }
            if (item.children && (item.children.length > 0)) {
                return (
                    <TreeNode title={item.title} area={area} key={item.key} >
                        { this.loopCity(item.children, area) }
                    </TreeNode>
                )
            } else {
                return <TreeNode title={item.title} area={area} key={selectCity ? item.regionId : item.key} />
            }
        })
    }

    componentDidMount(){
        this.loadTreeData();
    }

    render() {
        const { areaName, showTree } = this.state;
        const { style = {}, selectCity = false, hasCheckedArea = [], placeholder = null } = this.props;
        const setting = {};
        if (selectCity) {
            setting.onSelect = this.onSelect;
        } else {
            setting.onCheck = this.onTreeCheck;
        }
        return (
            <span>
                <Input value={areaName} style={{width:150, ...style}} onClick={this.showTree} placeholder={ placeholder ? placeholder : selectCity ? '请选择城市' : '请选择大区或城市' } />
                <Modal
                    title="选择地区"
                    visible={showTree}
                    onCancel={this.hideTree}
                    className="preview-modal"
                    wrapClassName="vertical-center-modal"
                    width="400px"
                    footer={<Button key="back" type="ghost" size="large" onClick={this.hideTree}>确定</Button>}
                >
                    <div style={{padding:'30px 40px'}}>
                        <Tree
                            multiple={true}
                            {...setting}
                            checkable={!selectCity}
                            checkStrictly={true}
                            defaultCheckedKeys={hasCheckedArea}
                            defaultExpandedKeys={hasCheckedArea}
                        >
                            {this.getContent()}                     
                        </Tree>
                    </div>   
                </Modal>
            </span>
        );
    }
}

export default SelectProvince;



// WEBPACK FOOTER //
// ./src/components/common/SelectProvince.js